import React from "react"
import Button from "../Button/Button"

const RELATION_LABEL = {
  applicant: "Applicant",
  "co-applicant": "Co-applicant",
}

// frozen_by_enrollment and report_no_debts must never share copy: identical in the data,
// opposite in meaning.
const describeState = (subject) => {
  switch (subject.state) {
    case "report_with_debts": {
      const count = subject.debtCount || 0
      return `Report on file — ${count} ${count === 1 ? "account" : "accounts"}`
    }
    case "report_no_debts":
      return "Report on file — no accounts on it"
    case "report_unavailable":
      return "No usable report — the file is frozen or no record was found"
    case "frozen_by_enrollment": {
      const candidates = subject.candidateCount || 0
      return candidates > 0
        ? `Debts locked in at enrollment — ${candidates} new ${candidates === 1 ? "account" : "accounts"} awaiting review`
        : "Debts locked in at enrollment — a refresh will not change them"
    }
    case "missing_identity":
      return "Credit cannot be pulled — missing information"
    case "not_permitted":
      return "You do not have access to pull credit for this person"
    case "no_report":
    default:
      return "Credit has not been pulled"
  }
}

const HouseholdCoverage = ({ subjects = [], error = "", notice = "", action }) => {
  if (error) {
    return (
      <div className="mb-4 rounded-lg border border-error-main/40 bg-error-main/5 px-4 py-3">
        <p className="text-sm text-error-main">{error}</p>
      </div>
    )
  }

  if (!subjects.length && !notice) return null

  return (
    <div className="mb-4 rounded-lg border border-divider">
      {notice && (
        <div className="border-b border-divider bg-error-main/5 px-4 py-2.5">
          <p className="text-sm text-error-main">{notice}</p>
          {action && (
            <div className="mt-2">
              <Button onClick={action.onClick} size="sm" type="outlined">{action.label}</Button>
            </div>
          )}
        </div>
      )}
      {subjects.map((subject) => (
        <div
          key={subject.userId}
          className="flex flex-wrap items-center justify-between gap-2 border-b border-divider px-4 py-2.5 last:border-b-0"
        >
          <div className="flex items-center gap-2">
            <span className="text-sm font-semibold">{subject.displayName}</span>
            <span className="text-xs text-text-secondary">
              {RELATION_LABEL[subject.relation] || subject.relation}
            </span>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm">{describeState(subject)}</span>
            {subject.missingIdentity?.length > 0 && (
              <span className="text-xs text-text-secondary">
                {subject.missingIdentity.join(", ")}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

export default HouseholdCoverage
